var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitchSocialIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "24 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "default no-stroke",
    transform: "translate(27 3)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "path",
    d: "M18 0H2.5c-.3 0-.6.2-.8.4L.2 2.7c-.1.2-.2.4-.2.6V15c0 .6.4 1 1 1h3v2c0 .6.4 1 1 1h1.6c.3 0 .5-.1.7-.3L10 16h3.6c.3 0 .5-.1.7-.3l4.4-4.4c.2-.2.3-.4.3-.7V1c0-.6-.4-1-1-1m0 1v9.6L13.6 15H10c-.3 0-.5.1-.7.3L6.6 18H5v-2c0-.6-.4-1-1-1H1V3.3L2.5 1H18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "path",
    d: "M4 12h2.5c.3 0 .5.2.5.5v1.8l2.1-2.1c.1-.1.2-.1.4-.1h3.8L16 9.4V3H4v9zm2.5 4h-.2c-.2-.1-.3-.3-.3-.5V13H3.5c-.3 0-.5-.2-.5-.5v-10c0-.3.2-.5.5-.5h13c.3 0 .5.2.5.5v7c0 .1-.1.3-.1.4l-3 3c-.1.1-.2.1-.4.1H9.7l-2.9 2.9s-.2.1-.3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "path",
    d: "M11 10h2V5h-2v5zm1-4v3-3zM7 10h2V5H7v5zm1-4v3-3z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "alt",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "path",
    d: "M30.5 12H28V3h12v6.3L37.3 12h-3.8c-.1 0-.3.1-.3.1L31 14.2v-1.8c0-.2-.2-.4-.5-.4M42 0H26.5c-.3 0-.6.2-.8.4l-1.5 2.3c-.1.2-.2.4-.2.6V15c0 .6.5 1 1 1h3v2c0 .5.5 1 1 1h1.6c.3 0 .5-.1.7-.3L34 16h3.6c.3 0 .5-.1.7-.3l4.4-4.4c.2-.2.3-.4.3-.7V1c0-.5-.5-1-1-1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "path",
    d: "M35 10h2V5h-2v5zm1-4v3-3zM31 10h2V5h-2v5zm1-4v3-3z"
  }))));
}
SvgTwitchSocialIcon.displayName = 'TwitchSocialIcon';
export default SvgTwitchSocialIcon;